module.exports = __webpack_public_path__ + "img/header_milovat_pohyb.16ce0756.jpg";